/* eslint-disable camelcase */
const TheStyles_CONTENT_LOAD = 'TheStyles/CONTENT_LOAD';
const TheStyles_SET_CONTENT = 'TheStyles/SET_CONTENT';

export default {
    TheStyles_CONTENT_LOAD,
    TheStyles_SET_CONTENT,
};
